export default __webpack_public_path__ + "static/media/BOProto.c24bb818.jpg";